<!--
 * @description: 我的奖励限流
 * @Author: WE1ZHANTA0
 * @Creat: 2020-03-07 12:15:38
 * @lastTime: 2020-03-07 13:25:42
 * @LastAuthor: WE1ZHANTA0
 -->
<template>
  <div class="awardLimit">
    <div class="awardMask"></div>
    <div class="limitDialog">
      <div class="limitImg">
        <img src="//static.yunjiglobal.com/qnUpload/frontend/redEnvelope/soHoting.png" alt="">
      </div>
      <div class="limitTitle">活动太火爆，请稍后再试～</div>
      <div class="limitBtn" @click="reFresh">
        点击重试
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  created() {},
  methods: {
    close() {
      this.$emit('awardClose')
    },
    reFresh() {
      this.$emit('awardRefresh')
    }
  }
}
</script>

<style lang="less" scoped>
.awardLimit{
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  .awardMask{
    position: absolute;
    opacity: 0.5;
    background: #000000;
    width: 100%;
    height: 100%;
  }
  .limitDialog{
    position: relative;
    width: 5.7rem;
    height: 5.04rem;
    background: #FFFFFF;
    box-shadow: 0 10px 20px 0 rgba(0,0,0,0.04);
    border-radius: 0.16rem;
    padding: 0 0.48rem;
    .limitImg{
      margin-top: 0.48rem;
      text-align: center;
      img {
        width: 2.2rem;
        height: 1.96rem;
      }
    }
    .limitTitle{
      margin-top: 0.32rem;
      font-size: 0.32rem;
      color: #262626;
      text-align: center;
      line-height: 0.44rem;
      font-family: PingFangSC-Semibold
    }
    .limitBtn{
      margin-top: 0.48rem;
      width: 100%;
      height: 0.88rem;
      background: #F61143;
      border-radius: 0.44rem;
      font-family: PingFangSC-Medium;
      font-size: 0.28rem;
      color: #FFFFFF;
      text-align: center;
      line-height: 0.88rem;
    }
  } 
}
</style>
